import styled, { keyframes } from 'styled-components';
import arrowDown from '../../assets/arrow-ios-down.svg';
import arrowUp from '../../assets/arrow-ios-up.svg';

interface ColorContainerProps {
  isRedCorner: boolean;
}

interface FightDataContainerProps {
  rr: number;
  rg: number;
  rb: number;
  br: number;
  bg: number;
  bb: number;
}

export const Container = styled.div`
  width: 100%;
  height: 95vh;
  display: flex;
  font-size: 18px;
  justify-content: space-between;

  .scout-section {
    // width: 33%;
    // height: 95%;
  }
`;

export const FightContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  width: 400px;

  .buttons-container {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
  }
`;

const appear = keyframes`
  from {
    opacity: 0;
    transform: translateY(-200px);
  }
  to {
    opacity: 1;
    transform: translateY(0)
  }
`;

export const ModalTitle = styled.div`
  display: flex;
  justify-content: space-around;
  .title {
    padding: 0 0 12px 0;
    border-bottom: 2px solid rgba(42, 42, 42, 0.1);
    width: 80%;
    h2 {
      text-align: center;

      /* Heading/H3 */
      font-family: Montserrat, sans-serif;
      font-style: normal;
      // font-weight: 600;
      line-height: 38.4px; /* 120% */
      color: rgb(107, 121, 151);
    }
  }
`;
export const ModalContent = styled.div`
  display: flex;
  justify-content: space-around;
  align-content: center;
  font-family: Montserrat, sans-serif;
  [class^='-container'],
  [class*='-container'] {
    width: 45%;
  }
  margin: 20px 0;

  .content {
    font-size: 1.2em;
    align-items: center;
  }

  .official-time {
    width: 100%;
    display: flex;
    justify-content: space-around;
  }
  .time-input {
    width: 30%;
    background-color: 'black';
    height: 38px;
  }

  .update-time,
  .official-time,
  .score-input {
    background-color: white;
    border: 1px solid #cccccc;
    font-weight: 500;
    border-radius: 4px;
    padding: 2px 8px;
    width: 40%;
    color: #6f7b94;
    display: flex;
    align-items: center;
    min-height: 38px;

    &:hover {
      border-color: #b3b3b3;
    }

    input {
      width: 100%;

      flex: 1;
      background: transparent;
      border: 0;
      color: #2a2a2a;

      &::placeholder {
        color: #6f7b94;
      }
    }
  }
`;

export const FightDataContainer = styled.div<FightDataContainerProps>`
  display: flex;
  // height: 50%;
  min-height: 262px;
  // padding: 15px;
  margin-top: 40px;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  // border: 2px solid rgba(255, 144, 0, 0.7);
  animation: ${appear} 1.5s;
  max-width: 400px;

  // background: linear-gradient(
  //   90deg,
  //   rgba(255, 144, 0, 0.1) 0%,
  //   rgba(255, 144, 0, 0.07) 35%,
  //   rgba(255, 144, 0, 0.03) 100%
  // );
  [class^='-container'],
  [class*='-container'] {
    width: 100%;
    color: #8395BA;
  }
  .round-watch{
    width: 100%;
    height: 64px;
    background: var(--global-07-black, #2A2A2A);
    padding: 8px;
    text-align: center;
    font-family:'Montserrat, sans-serif';
    font-size: 40px;
    font-style: normal;
    font-weight: 300;
    line-height: 48px; /* 120% */
  }
  .event-name {
    font-size: 0.9em;
  }

  .fighter-name {
    font-size: 1.2em;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .status {
    width: 100%;
    height: 32px;
    background-color: #CCD5E6;
    text-align: center;
    padding: 4px;
    margin: 8px 0 0 0;

    span {
      text-decoration: none;
      transition: ease 0.3s;
      color: var(--global-07-black, #2A2A2A);
      text-align: center;
      /* Heading/H5 */
      font-family: Montserrat, sans-serif;
      font-size: 20px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px; /* 120% */
      &:hover {
        font-size: 0.85em;
      }
    }

  }

  .round {
    padding: 1%;
    border-radius: 5px;

    &:hover {
      cursor: pointer;
      background: rgba(1, 1, 1, 0.5);
    }
  }

  .domain {
    width: 100%;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    min-height: 72px;
    margin: 8px 0 0 0;

    .current-stance{
      height: 32px;
      width: 100%;
      text-align: center;
      color: #FFF;
      font-family: Montserrat, sans-serif;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      margin: 8px 0 0 0;

    }
    .current-domain{
      display: flex;
      align-items: center;
      justify-content: space-around;
      height: 32px;
      width: 100%;
      text-align: center;
      color: #FFF;
      font-family: Montserrat, sans-serif;
      font-size: 24px;
      font-style: normal;
      font-weight: 700;
      line-height: 24px;
      margin: 8px 0 0 0;

    }

    .red {
      background-color: rgba(
        ${(props) => props.rr},
        ${(props) => props.rg},
        ${(props) => props.rb},
        1
      );
    }

    .blue {
      background-color: rgba(
        ${(props) => props.br},
        ${(props) => props.bg},
        ${(props) => props.bb},
        1
      );
    }

    .neutral {
      background-color: rgba(107, 121, 151, 1);
    }

    .standing-color {
      background-color: rgba(255, 171, 7, 1);
    }

    .ground-color {
      background-color: rgba(198, 47, 255, 1);
    }

    .fence-color {
      background-color: rgba(169, 94, 19, 1);
    }

    .true-color {
      background-color: rgba(8, 185, 89, 1);
    }
    .false-color {
      background-color: rgba(255, 141, 7, 1);
    }

    .neutral-color {
      background-color: rgba(107, 121, 151, 1);
      color: #fff;

    }

  }
  .score-container {
    display: flex;
    width: 100%;
    justify-content: space-around;
    margin: 8px 0 0 0;

    .score-input {
      background-color: white;
      border: 1px solid #cccccc;
      font-weight: 500;
      border-radius: 4px;
      padding: 2px 8px;
      color: #6f7b94;
      display: flex;
      align-items: center;
      min-height: 24px;

      &:hover {
        border-color: #b3b3b3;
      }

      input {
        width: 100%;

        flex: 1;
        background: transparent;
        border: 0;
        color: #2a2a2a;

        &::placeholder {
          color: #6f7b94;
        }
      }
    }

    .red-score,
    .blue-score {
      max-width: 30%;
      display: flex;
      flex-direction: column;
      align-items: center;
    }
    .red-score button,
    .blue-score button {
      background: rgba(1, 128, 199, 1);
      color: #fff;
      height: 20px;
      border-radius: 10px;
      border: 0;
      padding: 0 16px;
      color: #312e38;
      width: 100%;
      font-weight: 500;
      margin-top: 16px;
    }
  }

  .select-round{
    width: 100%;
    margin: 8px 0 0 0;
  }
  .badges{
    display: flex;
    justify-content: space-between;
    width: 100%;
    margin: 32px 0 0 0;
  }
  }
`;

export const LogsContainer = styled.div`
  display: flex;
  min-height: 50%;
  max-height: 55%;
  padding: 1%;
  margin-top: 24px;
  margin-bottom: 32px;
  overflow-y: auto;
  &::-webkit-scrollbar {
    display: none;
  }

  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */

  flex-direction: column;
  font-size: 0.8em;
  align-items: center;
  justify-content: flex-start;
  opacity: 1;

  .swiper {
    margin: 0;
    width: 100%;
    height: 100%;
    z-index: 0;
  }
  .swiper-wrapper {
    height: 100%;
  }

  .swiper-slide {
    max-width: 95%;
  }
  .custom-scrollbar {
    width: 10px;
  }
    
  .prev {
    height: 40px;
    width: 40px;
    background: url(${arrowUp});
  }

  .next {
    height: 40px;
    width: 40px;
    background: url(${arrowDown});
  }
`;

export const ColorContainer = styled.div<ColorContainerProps>`
  display: flex;
  flex-direction: column;
  align-items: ${({ isRedCorner }) =>
    isRedCorner ? 'flex-end' : 'flex-start'};
`;

/**
 * Confirmação por checkbox do modal de reset. Não virou componente em
 * src/components porque é o único uso — o repo não tem um Checkbox.
 */
export const ConfirmCheckbox = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  cursor: pointer;
  user-select: none;
  font-family: Montserrat, sans-serif;
  font-size: 1em;
  color: rgb(107, 121, 151);

  input[type='checkbox'] {
    width: 18px;
    height: 18px;
    cursor: pointer;
    accent-color: rgba(1, 128, 199, 1);
  }
`;
